export const VIDEO_OBJECT_REMAP = {
  Id: 'id',
  ExternalId: 'externalId',
  Title: 'title',
  Description: 'description',
  PublishedOn: 'publishedOn',
  ThumbnailUrl: 'thumbnailUrl'
}
